<script setup>
    import { router } from '@inertiajs/vue3';
    import { ref } from 'vue';
    import CountUp from 'vue-countup-v3';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        toolkit: Object,
        currentToolkitTeams: Object,
        currentUserTeam: Number,
        loggedInUserId: Number,
        activeToolkits: Array,
        previousToolkits: Array,
        loggedInUser: Object,
    });

    const enabling = ref(false);

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    //console.log(programme);

    const currentTeamToolkit = props.currentToolkitTeams.filter(function( index ) {
        return index.id === props.currentUserTeam;
    });

    const activeToolkits = props.activeToolkits;
    const previousToolkits = props.previousToolkits;

    const anyToolkits = props.activeToolkits.length > 0 ? true : false;
    const anyPastToolkits = props.previousToolkits.length > 0 ? true : false;

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }

    //calculate carbon savings
    const totalCarbonSavings = () => {
        let savings = 0;
        if (currentTeamToolkit) {
            savings += currentTeamToolkit[0].totalCarbonSaved;
        }

        if (previousToolkits) {
            previousToolkits.forEach((element) => savings += element.totalCarbonSaved);
        }

        return savings;
    }

    const convertToObject = (json) => {
        if (json.constructor.name != 'Object') {
            json = JSON.parse(json)
        }
        return json;
    }

    const default_text = router.page.props.ziggy.default_text;
    let carbon_widget_text = null;
    let organisationCarbonWidgetText = null;

    //console.log(locale.value, organisation.carbon_widget_text);

    if (organisation && organisation.carbon_widget_text) {
        organisation.carbon_widget_text = convertToObject(organisation.carbon_widget_text);
        organisationCarbonWidgetText = Object.values(organisation.carbon_widget_text).every((x) => x === null);
    }

    if (organisation && !organisationCarbonWidgetText) { //if all object keys are not null
        carbon_widget_text = organisation.carbon_widget_text;
    } else if (default_text){
        carbon_widget_text = default_text.filter((item) => {
            return item.key == "carbon_widget_text";
        });
        carbon_widget_text = carbon_widget_text[0].content;

        if (carbon_widget_text) {
            carbon_widget_text = convertToObject(carbon_widget_text);
        }
    }

</script>

<template>
    <div class="dashboard-widget widget previous-toolkits-widget">
        <div class="flex justify-between widget-header">
            <span>{{ $t('dashboard.widgets.carbon_savings.title') }}</span>
            <span class="material-icons-outlined">energy_savings_leaf</span>
        </div>
        <div class="flex flex-row flex-wrap content-center justify-center w-full widget-content">
            <div class="p-5 sm:w-full md:w-1/2">
                <div v-if="carbon_widget_text && (carbon_widget_text[$i18n.locale] || carbon_widget_text[$i18n.fallbackLocale])" v-html="carbon_widget_text[$i18n.locale] ? carbon_widget_text[$i18n.locale] : carbon_widget_text[$i18n.fallbackLocale]"></div>
                <div v-else>
                    <p>{{ $t('dashboard.widgets.carbon_savings.savings_text_1') }}</p>
                </div>
                <p v-html="$t('dashboard.widgets.carbon_savings.carbon_policy', {link: route(urlNamePrefix+'page', {page:'carbon-policy'})})"></p>
            </div>
            <div class="text-center sm:w-full md:w-1/2 place-content-center">
                <div class="content-center w-1/2 rounded-full" style="background-color: #3D5567; width: 15vw; height: 15vw; min-width: 250px; min-height: 250px; margin: 0 auto;">
                    <p class="text-sm font-bold text-white" v-html="$t('dashboard.widgets.carbon_savings.savings_prepend', { team_name: team_name })"></p>
                    <div class="text-6xl font-extrabold text-white">
                        <count-up
                            :end-val=totalCarbonSavings()
                            :options="{
                                decimal: '.',
                                decimalPlaces: 2,
                                enableScrollSpy: true,
                                scrollSpyDelay: 1000,
                                scrollSpyOnce: true
                            }"
                        >
                        </count-up>
                    </div>
                    <p class="pt-5 text-sm font-bold text-white" v-html="$t('dashboard.widgets.carbon_savings.savings_append')"></p>
                </div>
                <p class="mt-2 text-xs" v-html="$t('dashboard.widgets.carbon_savings.savings_current_toolkit', {currentSavings: currentTeamToolkit[0].totalCarbonSaved})"></p>
            </div>

        </div>
    </div>
</template>
